<!-- Page Header -->
<section class="cuspage-hero cuspage-hero--detail">
  <div class="cuspage-hero__bg"></div>
  <div class="container">
    <div class="cuspage-hero__content">
      <button class="det-back-hero" (click)="goBack()">
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round">
          <path d="M10 3L5 8l5 5"/>
        </svg>
        {{ 'annuaire_det_retour' | translate }}
      </button>
      <h1 class="cuspage-hero__title" *ngIf="!loading && profile">{{ displayName }}</h1>
      <h1 class="cuspage-hero__title" *ngIf="loading">{{ 'annuaire_chargement' | translate }}</h1>
    </div>
  </div>
</section>

<section class="arp-det-section">
  <div class="container">

    <!-- Loading -->
    <div *ngIf="loading" class="arp-loading-state">
      <div class="arp-loader"></div>
      <p>{{ 'annuaire_det_chargement' | translate }}</p>
    </div>

    <!-- Error -->
    <div *ngIf="error && !loading" class="arp-alert-error text-center">{{ error }}</div>

    <ng-container *ngIf="!loading && !error && profile">

      <!-- ════ Fiche INFLUENCEUR — la photo porte la fiche ════ -->
      <div class="arp-dinf-hero arp-det-anim" *ngIf="type === 'influencer'">
        <div class="arp-dinf-hero__media">
          <!-- Sans photo, ou si elle ne se charge pas : image par défaut de l'annuaire -->
          <img [src]="profile.photo_url || noPhoto" [alt]="displayName"
               [class.is-placeholder]="!profile.photo_url" (error)="onImgError($event)">
          <span class="arp-dinf-hero__scrim" aria-hidden="true"></span>
          <span class="arp-dinf-hero__niche" *ngIf="profile.niche" dir="auto">{{ profile.niche }}</span>
        </div>

        <div class="arp-dinf-hero__body">
          <span class="arp-dinf-hero__eyebrow" style="display: none;">{{ 'annuaire_influenceur_label' | translate }}</span>

          <h2 class="arp-dinf-hero__name" dir="auto">
            <span>{{ displayName }}</span>
            <svg *ngIf="profile.is_verified" class="arp-dinf-hero__check"
                 viewBox="0 0 24 24" fill="currentColor"
                 [attr.aria-label]="'annuaire_verifie' | translate">
              <path d="M12 2l2.4 1.8 3-.2.9 2.9 2.5 1.6-1.1 2.8 1.1 2.8-2.5 1.6-.9 2.9-3-.2L12 22l-2.4-1.8-3 .2-.9-2.9-2.5-1.6 1.1-2.8-1.1-2.8 2.5-1.6.9-2.9 3 .2L12 2z"/>
              <path d="M10.6 14.6L8.2 12.2l1.1-1.1 1.3 1.3 3.4-3.4 1.1 1.1-4.5 4.5z" fill="#0f2723"/>
            </svg>
          </h2>

          <p class="arp-dinf-hero__bio" *ngIf="profile.bio" dir="auto">{{ profile.bio }}</p>

          <div class="arp-dinf-hero__stats"
               *ngIf="profile.total_followers || profile.social_accounts?.length || profile.city">
            <div class="arp-dinf-stat" *ngIf="profile.total_followers">
              <strong>{{ formatNum(profile.total_followers) }}</strong>
              <span>{{ 'annuaire_abonnes' | translate }}</span>
            </div>
            <div class="arp-dinf-stat" *ngIf="profile.social_accounts?.length">
              <strong>{{ profile.social_accounts.length }}</strong>
              <span>{{ 'annuaire_plateformes' | translate }}</span>
            </div>
            <div class="arp-dinf-stat" *ngIf="profile.city">
              <strong dir="auto">{{ profile.city }}</strong>
              <span>{{ 'annuaire_col_ville' | translate }}</span>
            </div>
          </div>

          <a *ngIf="profile.website" class="arp-dinf-hero__site"
             [href]="profile.website" target="_blank" rel="noopener" dir="auto">
            <svg viewBox="0 0 14 14" aria-hidden="true"><circle cx="7" cy="7" r="5.5" fill="none" stroke="currentColor" stroke-width="1.2"/><path d="M7 1.5C5.5 3 4.5 5 4.5 7s1 4 2.5 5.5M7 1.5C8.5 3 9.5 5 9.5 7s-1 4-2.5 5.5M1.5 7h11" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>
            {{ profile.website }}
          </a>
        </div>
      </div>

      <!-- ════ Fiche CALLIGRAPHE — même présentation que les annonceurs ════ -->
      <div class="arp-dinf-hero arp-det-anim" *ngIf="type === 'calligraphe'">
        <div class="arp-dinf-hero__media">
          <!-- Sans photo, ou si elle ne se charge pas : image par défaut de l'annuaire -->
          <img [src]="profile.photo_url || noPhoto" [alt]="displayName"
               [class.is-placeholder]="!profile.photo_url" (error)="onImgError($event)">
          <span class="arp-dinf-hero__scrim" aria-hidden="true"></span>
          <span class="arp-dinf-hero__niche" *ngIf="profile.specialty" dir="auto">{{ profile.specialty }}</span>
        </div>

        <div class="arp-dinf-hero__body">
          <span class="arp-dinf-hero__eyebrow">{{ 'annuaire_calligraphe_label' | translate }}</span>

          <h2 class="arp-dinf-hero__name" dir="auto">
            <span>{{ displayName }}</span>
            <svg *ngIf="profile.is_verified" class="arp-dinf-hero__check"
                 viewBox="0 0 24 24" fill="currentColor"
                 [attr.aria-label]="'annuaire_verifie' | translate">
              <path d="M12 2l2.4 1.8 3-.2.9 2.9 2.5 1.6-1.1 2.8 1.1 2.8-2.5 1.6-.9 2.9-3-.2L12 22l-2.4-1.8-3 .2-.9-2.9-2.5-1.6 1.1-2.8-1.1-2.8 2.5-1.6.9-2.9 3 .2L12 2z"/>
              <path d="M10.6 14.6L8.2 12.2l1.1-1.1 1.3 1.3 3.4-3.4 1.1 1.1-4.5 4.5z" fill="#0f2723"/>
            </svg>
          </h2>

          <p class="arp-dinf-hero__bio" *ngIf="profile.bio" dir="auto">{{ profile.bio }}</p>

          <div class="arp-dinf-hero__stats"
               *ngIf="profile.city || profile.employee_count || profile.social_accounts?.length">
            <div class="arp-dinf-stat" *ngIf="profile.city">
              <strong dir="auto">{{ profile.city }}</strong>
              <span>{{ 'annuaire_col_ville' | translate }}</span>
            </div>
            <div class="arp-dinf-stat" *ngIf="profile.employee_count">
              <strong>{{ profile.employee_count }}</strong>
              <span>{{ 'annuaire_employes' | translate }}</span>
            </div>
            <div class="arp-dinf-stat" *ngIf="profile.social_accounts?.length">
              <strong>{{ profile.social_accounts.length }}</strong>
              <span>{{ 'annuaire_plateformes' | translate }}</span>
            </div>
          </div>

          <p class="arp-dinf-hero__addr" *ngIf="profile.workshop_address" dir="auto">
            <svg viewBox="0 0 14 14" aria-hidden="true"><path d="M7 1.5c2.2 0 4 1.8 4 4 0 3-4 7-4 7s-4-4-4-7c0-2.2 1.8-4 4-4z" fill="none" stroke="currentColor" stroke-width="1.2"/><circle cx="7" cy="5.5" r="1.4" fill="currentColor"/></svg>
            {{ profile.workshop_address }}
          </p>

          <a *ngIf="profile.website" class="arp-dinf-hero__site"
             [href]="profile.website" target="_blank" rel="noopener" dir="auto">
            <svg viewBox="0 0 14 14" aria-hidden="true"><circle cx="7" cy="7" r="5.5" fill="none" stroke="currentColor" stroke-width="1.2"/><path d="M7 1.5C5.5 3 4.5 5 4.5 7s1 4 2.5 5.5M7 1.5C8.5 3 9.5 5 9.5 7s-1 4-2.5 5.5M1.5 7h11" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>
            {{ profile.website }}
          </a>
        </div>
      </div>

      <!-- ════ Fiche AGENCE — la dénomination porte la fiche ════ -->
      <div class="arp-dag-hero arp-det-anim" *ngIf="type === 'agency'">
        <span class="arp-dag-hero__rail" aria-hidden="true"></span>

        <div class="arp-dag-hero__head">
          <div class="arp-dag-hero__title">
            <span class="arp-dag-hero__eyebrow">{{ 'annuaire_agence_label' | translate }}</span>
            <h2 class="arp-dag-hero__name" dir="auto">{{ displayName }}</h2>
            <span class="arp-dag-hero__rule" aria-hidden="true"></span>
          </div>

          <div class="arp-dag-hero__mark">
            <img [src]="profile.logo_url || noPhoto" [alt]="displayName"
                 [class.is-placeholder]="!profile.logo_url" (error)="onImgError($event)">
          </div>
        </div>

        <span *ngIf="profile.is_verified" class="arp-dag-hero__vchip">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M20 6L9 17l-5-5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ 'annuaire_agree_arp' | translate }}
        </span>

        <p class="arp-dag-hero__bio" *ngIf="profile.bio" dir="auto">{{ profile.bio }}</p>

        <div class="arp-dag-hero__facts">
          <div class="arp-dag-fact" *ngIf="profile.city">
            <span>{{ 'annuaire_col_ville' | translate }}</span>
            <strong dir="auto">{{ profile.city }}</strong>
          </div>
          <div class="arp-dag-fact" *ngIf="profile.employee_count">
            <span>{{ 'annuaire_employes' | translate }}</span>
            <strong>{{ profile.employee_count }}</strong>
          </div>
          <div class="arp-dag-fact" *ngIf="profile.founded_year">
            <span>{{ 'annuaire_fonde_en' | translate }}</span>
            <strong>{{ profile.founded_year }}</strong>
          </div>
          <div class="arp-dag-fact" *ngIf="profile.website">
            <span>{{ 'annuaire_col_site' | translate }}</span>
            <a [href]="profile.website" target="_blank" rel="noopener" dir="auto">{{ profile.website }}</a>
          </div>
        </div>
      </div>

      <!-- Body grid -->
      <div class="arp-det-body">

        <!-- Left column -->
        <div class="arp-det-col-main">

          <!-- Agency details -->
          <div class="arp-det-card arp-det-anim" style="animation-delay:120ms"
               *ngIf="type === 'agency' && (profile.services || profile.registration_number)">
            <div class="arp-det-card-hd">{{ 'annuaire_det_agence' | translate }}</div>
            <div class="arp-det-fields">
              <div class="arp-det-field" *ngIf="profile.services">
                <span class="arp-det-fl">{{ 'annuaire_services' | translate }}</span>
                <span class="arp-det-fv">{{ profile.services }}</span>
              </div>
              <div class="arp-det-field" *ngIf="profile.registration_number">
                <span class="arp-det-fl">{{ 'annuaire_num_enreg' | translate }}</span>
                <span class="arp-det-fv">{{ profile.registration_number }}</span>
              </div>
            </div>
          </div>

          <!-- Licences -->
          <div class="arp-det-card arp-det-anim" style="animation-delay:160ms"
               *ngIf="profile.licenses?.length > 0">
            <div class="arp-det-card-hd">
              <span>{{ 'annuaire_det_licences' | translate }}</span>
              <span class="arp-det-count-badge">{{ profile.licenses.length }}</span>
            </div>
            <div class="arp-lic-list">
              <div class="arp-lic-row" *ngFor="let lic of profile.licenses">
                <div class="arp-lic-ic" [ngClass]="'arp-lic-ic--' + licenseColor(lic.status)">
                  <svg viewBox="0 0 14 14"><rect x="1" y="2" width="12" height="10" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.2"/><path d="M4 7h2m-2 2.5h6M4 5h6" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>
                </div>
                <div class="arp-lic-info">
                  <div class="arp-lic-ref">{{ lic.reference_number }}</div>
                  <div class="arp-lic-type">{{ lic.type }}<ng-container *ngIf="lic.subtype"> — {{ lic.subtype }}</ng-container></div>
                </div>
                <div class="arp-lic-right">
                  <span class="arp-lic-status" [ngClass]="'arp-lic-status--' + licenseColor(lic.status)">{{ lic.status_label }}</span>
                  <div class="arp-lic-date" *ngIf="lic.approved_at">{{ lic.approved_at }}</div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- Right column -->
        <div class="arp-det-col-side">

          <!-- Social accounts -->
          <div class="arp-det-card arp-det-anim" style="animation-delay:140ms"
               *ngIf="profile.social_accounts?.length > 0">
            <div class="arp-det-card-hd">
              <span>{{ 'annuaire_det_reseaux' | translate }}</span>
              <span class="arp-det-count-badge">{{ profile.social_accounts.length }}</span>
            </div>
            <div class="arp-soc-list">
              <div class="arp-soc-row" *ngFor="let s of profile.social_accounts">
                <div class="arp-soc-ic">{{ platformIcon(s.platform) }}</div>
                <div class="arp-soc-info">
                  <div class="arp-soc-plat">{{ platformLabel(s.platform) }}</div>
                  <div class="arp-soc-usr">&#64;{{ s.username }}</div>
                  <div class="arp-soc-cnt" *ngIf="s.followers_count">{{ formatNum(s.followers_count) }} {{ 'annuaire_abonnes' | translate }}</div>
                  <div class="arp-soc-ct" *ngIf="s.content_type">{{ s.content_type }}</div>
                </div>
                <div class="arp-soc-right">
                  <span class="arp-soc-primary" *ngIf="s.is_primary">{{ 'annuaire_det_principal' | translate }}</span>
                  <a *ngIf="s.profile_url" class="arp-soc-link" [href]="s.profile_url" target="_blank" rel="noopener">{{ 'annuaire_det_voir' | translate }} →</a>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>

    </ng-container>

  </div>
</section>
